import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../../views/client/axiosClient'
import Constants from './constants'
import * as actions from './actions'
import { handleRequest, transfersFromCached } from '../../../lib/common'

function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function exportXlsRequestApi(formData) {
  const url = Constants.LOAD_ACTIVITIES_EXCEL_API + "?store_id=" + formData.store_id + "&start_date=" + formData.start_date + "&end_date=" + formData.end_date
    + "&user_id=" + formData.user_id + "&activity_type=" + (formData.activity_type == undefined ? 0 : formData.activity_type) + "&keyword=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* loadUsers({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.LOAD_USERS_API,
      payload
    )
    const { data } = yield call(handleRequest, request)
    yield put(actions.setUsers(data))
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* updateActivityTypes({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.UPDATE_ACTIVITIES_API,
      payload
    )
    const { code, data, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(actions.setError(message))
    }
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* removeActivities({ payload, callback }) {
  try {
    yield put(actions.setLoading(true))
    const request = axiosApi().post(
      Constants.REMOVE_ACTIVITIES_API,
      payload
    )
    const { code, data, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(actions.setError(message))
    }
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* loadActivityTypes({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.LOAD_ACTIVITYTYPES_API,
      payload
    )
    const { code, data, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(actions.setError(message))
    }
    yield put(actions.setActivityTypes(transfersFromCached(data)));
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* loadActivities({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.LOAD_ACTIVITIES_API,
      payload
    )
    const { code, data, message } = yield call(handleRequest, request);
    if (code != 200) {
      yield put(actions.setError(message))
    }
    yield put(actions.setActivities(data))
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* loadExcelActivities({ payload, callback }) {
  try {
    const { code, data, message } = yield call(exportXlsRequestApi, payload);
    if (code != 200) {
      yield put(actions.setError(message))
    }
    yield put(actions.setExcelActivities(data))
    if (callback) {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(actions.setError(error.toString()))
  } finally {
    yield put(actions.setLoading(false))
  }
}

function* activitiesWatcher() {
  yield [
    yield takeLatest(Constants.LOAD_ACTIVITYTYPES, loadActivityTypes),
    yield takeLatest(Constants.LOAD_USERS, loadUsers),
    yield takeLatest(Constants.LOAD_ACTIVITIES, loadActivities),
    yield takeLatest(Constants.LOAD_ACTIVITIES_XLS, loadExcelActivities),
    yield takeLatest(Constants.UPDATE_ACTIVITYTYPES, updateActivityTypes),
    yield takeLatest(Constants.REMOVE_ACTIVITIES, removeActivities),
  ]
}

export default activitiesWatcher



// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/sagas.js